import { Controller } from "stimulus";
import { stockChartOptions } from "../config";

// Action type
const ACTION_TYPE = {
  DURATION: "duration",
  MODE_LINE: "mode-line",
  MODE_CIRCLE: "mode-circle"
};

// Whether or not we display markers
const CHART_MODE = {
  CIRCLE: "circle",
  LINE: "line"
};

let Highcharts;

export default class extends Controller {
  static targets = ["chart", "spinner", "toolbar"];

  connect() {
    $(this.spinnerTarget).show();

    // COMPONENT PROPERTIES
    this.chartDataUrl = this.chartTarget.getAttribute("data-initial-url");
    this.chartMode = CHART_MODE.CIRCLE;

    Promise.all([import("highcharts/highstock")]).then(res => {
      Highcharts = res[0];

      this.renderChart(this.chartDataUrl, this.chartMode);
    });
  }

  renderChart(chartUrl, chartMode) {
    // We try to remember previous values and don't update if nothing changed.
    if (chartUrl === this._prevChartUrl && chartMode === this._prevChartMode) {
      return;
    }
    this._prevChartMode = chartMode;
    this._prevChartUrl = chartUrl;

    $(this.spinnerTarget).show();

    const chartContainerId = this.chartTarget.id;

    fetch(chartUrl, { credentials: "same-origin" })
      .then(response => response.json())
      .then(data => {
        const ratiosData = data.stats;

        const chart = Highcharts.StockChart(
          Object.assign(
            {
              yAxis: [
                {
                  showLastLabel: true,
                  opposite: false,
                  labels: {
                    style: {
                      color: "#56b4e9"
                    },
                    align: "left",
                    x: 0,
                    formatter() {
                      return this.value;
                    }
                  },
                  height: "100%"
                }
              ],
              tooltip: {
                formatter() {
                  return (
                    `<b>${chart.time.dateFormat("%a %d %b %Y, %H:%M:%S", this.x)}</b><br/>` +
                    "<b>Ratio: </b> " +
                    this.points[0].y +
                    "<br/>"
                  );
                }
              },
              series: [
                {
                  name: "Ratio",
                  type: "line",
                  data: ratiosData,
                  marker: {
                    enabled: chartMode === CHART_MODE.CIRCLE,
                    radius: 2
                  },
                  dataGrouping: {
                    enabled: false
                  }
                }
              ]
            },
            stockChartOptions(chartContainerId)
          )
        );

        $(this.spinnerTarget).hide();
      });
  }

  updateChart(e) {
    const buttonEl = e.currentTarget;
    const actionType = buttonEl.getAttribute("data-action-type");

    // Clear active on siblings
    const $buttonEl = $(buttonEl);
    $buttonEl.siblings().removeClass("active");
    setTimeout(() => {
      // not sure why setTimeout is needed, otherwise won't catch
      $buttonEl.addClass("active");
    });

    switch (actionType) {
      case ACTION_TYPE.MODE_CIRCLE:
        this.chartMode = CHART_MODE.CIRCLE;
        this.renderChart(this.chartDataUrl, this.chartMode);
        break;
      case ACTION_TYPE.MODE_LINE:
        this.chartMode = CHART_MODE.LINE;
        this.renderChart(this.chartDataUrl, this.chartMode);
        break;
      case ACTION_TYPE.DURATION:
        const dataUrl = buttonEl.getAttribute("data-btc-ratio-stats-url");
        this.chartDataUrl = dataUrl;
        this.renderChart(this.chartDataUrl, this.chartMode);
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./app/assets/webpack/controllers/btc_ratio_chart_controller.js